import { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Layout, usePageTitle } from "@/components/site/Layout";
import { api } from "@/lib/api";

export default function BookingCancel() {
  const [params] = useSearchParams();
  usePageTitle("Payment cancelled | Garage Getaway Beaumont");
  useEffect(() => {
    const ref = params.get("ref");
    if (ref) api.post(`/bookings/cancel-hold/${ref}`).catch(() => {});
  }, [params]);
  return (
    <Layout>
      <section className="px-5 py-20 max-w-2xl mx-auto" data-testid="booking-cancel-page">
        <h1 className="text-4xl sm:text-5xl font-medium">Payment cancelled</h1>
        <p className="mt-4 text-muted-foreground">No charge was made and your dates have been released. You're welcome to try again whenever you're ready.</p>
        <Link to="/book" className="inline-block mt-8 bg-primary text-primary-foreground px-6 py-3 rounded-full text-sm" data-testid="try-again-button">Choose dates again</Link>
      </section>
    </Layout>
  );
}
